var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInbDashboardLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H5.5C6.60457 1 7.5 1.89543 7.5 3V5.5C7.5 6.60457 6.60457 7.5 5.5 7.5H3C1.89543 7.5 1 6.60457 1 5.5V3Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5C1 11.3954 1.89543 10.5 3 10.5H5.5C6.60457 10.5 7.5 11.3954 7.5 12.5V15C7.5 16.1046 6.60457 17 5.5 17H3C1.89543 17 1 16.1046 1 15V12.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3C10.5 1.89543 11.3954 1 12.5 1H15C16.1046 1 17 1.89543 17 3V5.5C17 6.60457 16.1046 7.5 15 7.5H12.5C11.3954 7.5 10.5 6.60457 10.5 5.5V3Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5C10.5 11.3954 11.3954 10.5 12.5 10.5H15C16.1046 10.5 17 11.3954 17 12.5V15C17 16.1046 16.1046 17 15 17H12.5C11.3954 17 10.5 16.1046 10.5 15V12.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbDashboardLine);
export default __webpack_public_path__ + "static/media/icon-inb-dashboard-line.4968f37479de2b443558eea68945103f.svg";
export { ForwardRef as ReactComponent };